<!-- 轮播图 -->
<template>
	<div class="banner">
		<div class="swiper-img recommendPage">
			<swiper :options="swiperOption" ref="mySwiper" @slideChange="handleSlideChange">
				<swiper-slide v-for="(item, index) in swiperImg" :key="index">
					<div class="slide-content" @click="clickSwiperImg(item)">
						<div class="img-wrapper">
							<img :src="item.banner" alt="">
						</div>
						<p class="slide-title">{{ item.name }}</p>
					</div>
				</swiper-slide>
			</swiper>
		</div>
	</div>



</template>
<script>
// 引入插件
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import { ModulesRecommend } from "../../../config/interface.js"

export default {
	props: {
		type: Number,          //1:专栏模块; 2:会议模块; 3:前沿资讯模块;4:病例模块;5:器械模块
	},
	components: {
		swiper,
		swiperSlide
	},
	data() {
		return {
			swiperImg: [],    //轮播图列表
			active: 3,
			handleResize: null,
			swiperOption: {
				slidesPerView: 1.5,
				centeredSlides: true,
				loop: true,
				// slidesPerView : 'auto',
				effect: 'slide',  // 改为普通slide效果
				spaceBetween: 10, // 图片之间的间距
				initialSlide: 1,
				// loopedSlides: 8,
				// loopAdditionalSlides:5,
				autoplay: {
					delay: 6000,
					disableOnInteraction: false,  // 用户交互后不禁用自动切换
					pauseOnMouseEnter: true       // 鼠标悬停时暂停
				},

				// 添加以下配置优化响应式表现
				updateOnWindowResize: true,  // 窗口变化时更新swiper
				resizeObserver: true,        // 开启响应式监测
				observer: true,              // 监测自身变化
				observeParents: true,        // 监测父元素变化
				lazy: {
					loadPrevNext: true,        // 预加载前后slide
					loadPrevNextAmount: 1      // 预加载数量
				},
				// 添加循环相关配置
				speed: 600,               // 切换速度
				watchSlidesProgress: true,
			},
			timer: null
		}
	},
	computed: {
		// swiper() {
		// 	return this.$refs.mySwiper.swiper;
		// }
	},

	mounted() {
		this.getSwiperImg();

	},
	// 记得在组件销毁时移除事件监听
	beforeDestroy() {

	},
	methods: {
		//轮播图
		getSwiperImg() {
			let that = this
			const url = ModulesRecommend;
			const method = 'POST';
			let params = {
				module_id: this.type   //1:专栏模块; 2:会议模块; 3:前沿资讯模块;4:病例模块;5:器械模块; 6:首页;7:文章推荐
			}
			fetch(url, params, method)
				.then((res) => {
					if (res.code == 0) {
						let data = res.data;
						that.swiperImg = Array.isArray(res.data) ? res.data : Object.values(res.data);
						that.$nextTick(() => {
							if (that.$refs.mySwiper) {
								that.$refs.mySwiper.swiper.update();
							}
						});

					}
				})
		},
		handleSlideChange() {
			if (this.$refs.mySwiper) {
				this.currentIndex = this.$refs.mySwiper.swiper.activeIndex;
				// 先清除之前的定时器
				if (this.timer) {
					clearTimeout(this.timer);
					this.timer = null;
				}
				if (this.currentIndex == this.swiperImg.length - 1) {
					this.timer = setTimeout(() => {
						this.$refs.mySwiper.swiper.slideTo(1, 1000, false);
					}, 6000)

				}

			}
		},
		//点击轮播图
		clickSwiperImg(item) {
			console.log(item);
			//0:专栏;1:文章;2:会议
			switch (item.resource_type) {
				case 0:
					this.$router.push({
						path: '/column/details',
						query: {
							id: item.resource_id
						}
					})
					break;
				case 1:
					if (item.bind_url) {
						window.location.href = item.bind_url;
					} else {
						this.$router.push({
							path: '/exclusiveView/details',
							query: {
								article_id: item.resource_id
							}
						})
					}
					break;
				case 2:
					if (item.resource_id == 286) {
						this.$router.push({
							path: '/CEC2022/index'
						})
					}
					else if (item.resource_id == 348) {
						this.$router.push({
							path: '/CEC2023/index'
						})
					}
					else if (item.resource_id == 399) {
						this.$router.push({
							path: '/CVSCF2023/index'
						})
					} else if (item.resource_id == 483) {
						this.$router.push({
							path: '/XVC/index'
						})
					}

					else {
						this.$router.push({
							path: '/vascularNews/meeting/Index',
							query: {
								meeting_id: item.resource_id
							}
						})
					}
					break;
			}
		}

	}
}
</script>
<style lang="scss" scoped>
.recommendPage {
	padding: 12px;
	overflow: hidden;

	.swiper-container {
		overflow: visible;
		padding: 10px 0;
	}

	.swiper-slide {
		transition: all 0.4s ease;
		width: 100%;
		border-radius: 8px;
		overflow: hidden;

		.slide-content {
			position: relative;

			&::after {
				content: '';
				position: absolute;
				left: 0;
				bottom: 0;
				width: 100%;
				height: 50%; // 渐变高度占图片的一半
				background: linear-gradient(to bottom, transparent, rgba(0, 0, 0, 0.7));
				pointer-events: none; // 确保不影响点击事件
				z-index: 1;
			}
		}

		.img-wrapper {
			width: 100%;
			padding-top: 56.25%; // 16:9 比例
			position: relative;
		}

		img {
			position: absolute;
			top: 0;
			bottom: 0;
			left: 0;
			width: 100%;
			height: 100%;
			object-fit: cover;
			transition: all 0.4s ease;
			margin: 0;
		}

		&-active {
			transform: scale(1.15);
			z-index: 2;

			.slide-content {
				// box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
			}

			img {
				filter: brightness(100%);
			}
		}

		&:not(.swiper-slide-active) {
			transform: scale(0.85);
			// opacity: 0.5;

			.slide-content {
				filter: blur(2px);

			}
		}

		.slide-title {
			position: absolute;
			bottom: 10px;
			left: 50%;
			transform: translateX(-50%);
			width: 90%;
			// padding: 4px;
			// background: rgba(255, 255, 255, 0.9);
			border-radius: 15px;
			text-align: center;
			font-size: 12px;
			color: #fff;
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
			z-index: 2;
		}
	}
}
</style>


// WEBPACK FOOTER //
// src/pages/VascularSystem/components/Banner.vue